import React from 'react';
import styled from 'styled-components';

import { Link } from 'gatsby';

import { ActiveFilters } from './collection-breadcrumb';

const collectionLinks = [
    {
        title: 'Neckties',
        url: '/collections/neckties',
    },
    {
        title: 'Bowties',
        url: '/collections/bow-ties',
    },
    {
        title: 'Pocket Squares',
        url: '/collections/pocket-squares',
    },
    {
        title: 'Scarves',
        url: '/collections/scarves',
    },
    {
        title: 'Face Masks',
        url: '/collections/face-masks',
    },
    {
        title: 'Neck Gaiters',
        url: '/collections/neck-gaiters',
    },
    {
        title: 'Kimonos',
        url: '/collections/kimonos',
    },
    {
        title: 'Robes',
        url: '/collections/robes',
    },
    {
        title: 'Maternity',
        url: '/collections/maternity',
    },
];

const CollectionFilterLinklistContainer = styled.div``;

const CollectionFilterLinklist = ({ setActiveFilters, activeFilters }) => {
    return (
        <CollectionFilterLinklistContainer>
            <div className="filter-linklist">
                <ul>
                    {collectionLinks &&
                        collectionLinks.map((link, index) => {
                            const { title, url } = link;

                            return (
                                <li key={index}>
                                    <Link activeClassName="active" to={url}>
                                        {title}
                                    </Link>
                                </li>
                            );
                        })}
                </ul>

                <div className="mobile-active-filters">
                    <ActiveFilters
                        setActiveFilters={setActiveFilters}
                        activeFilters={activeFilters}
                    />
                </div>
            </div>
        </CollectionFilterLinklistContainer>
    );
};

export default CollectionFilterLinklist;
